import { isStdTestCourse } from 'my-core/course-utils';

import { useCurrentUser } from './redux';

const PURCHASED_STATUSES = ['active', 'pending_payment', 'expired'];

export default function useHasPurchasedTestPrep() {
  const currentUser = useCurrentUser({ includeCourses: true });
  // Head Start students are still trialing, but they have bought a schedule
  return currentUser.user_courses.some(
    uc =>
      isStdTestCourse(uc.course) &&
      (PURCHASED_STATUSES.includes(uc.status) || (uc.status === 'trialing' && !!uc.course_schedule_id)),
  );
}
